'use strict';

var _ = require('lodash');

function BreadcrumbsDirective ($compile) {

  var link = function (scope, $el, attrs, ctrls) {
    var ctrl = ctrls[0];
    var pageCtrl = ctrls[1];
    var drawerCtrl = ctrls[2];

    $el.addClass('sb-nav-drawer-breadcrumbs');

    ctrl.init(pageCtrl.getId());

    var getBreadcrumbTemplate = function (viewId) {
      var scope_ = _.extend(scope.$new(), {
        loadView: drawerCtrl.setPageView.bind(drawerCtrl),
        viewId: viewId
      });
      var compiled = $compile('<a class="breadcrumb" ng-click="loadView(viewId)">{{::viewId}}</a>/')(scope_);
      return compiled;
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    ///////////////////////////////////////////////////////////////////////////////////////////////

    var onViewChange = function () {
      var viewStack = ctrl.getViewStack();

      $el.empty();

      // build the breadcrumbs template
      _.forEach(viewStack, function (viewId) {
        $el.append(getBreadcrumbTemplate(viewId));
      });
    };

    scope.$watch(pageCtrl.getAttr('view'), onViewChange);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    bindToController: true,
    controller: 'sbNavDrawerBreadcrumbsController',
    controllerAs: 'ctrl',
    link: link,
    require: ['sbNavDrawerPageBreadcrumbs', '^sbNavDrawerPage', '^sbNavDrawer'],
    restrict: 'EA',
    scope: true,
  };
}

module.exports = BreadcrumbsDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/breadcrumbs/BreadcrumbsDirective.js